<div class="ez-main-content"
     [ngStyle]="style">
    <div class="k-card flex-grow-1">
        <div class="ez-main-content-header flex-shrink-0">
            <div class="row no-gutters">
                <div class="col{{ screenSize }}-{{ titleWidth }}">
                    <div class="ez-page-title d-inline-flex align-items-center"
                         [ngClass]="titleClass">
                        <h3 class="pl-4 pr-3 py-2 d-inline-block position-relative">
                            <span class="material-icons position-absolute text-primary"
                                  style="font-size: 0.94em; left: 0; top: calc(50% - 0.47em);">{{ Icon }}</span>
                            {{ Title }}
                            <span *ngIf="helpFileName"
                                  kendoTooltip
                                  title="Help"
                                  class="k-icon k-font-icon k-i-help font-smaller-1 cursor-pointer align-baseline ml-2"
                                  (click)="openHelp()"></span>
                        </h3>
                    </div>
                </div>
                <div class="ez-page-header-container"
                     [ngClass]="rightHeaderClass">
                    <ng-content select="[header]"></ng-content>
                </div>
            </div>
        </div>

        <div class="ez-main-content-body flex-grow-1"
             [ngClass]="bodyClass">
            <ng-content select="[body]"></ng-content>
        </div>
    </div>
</div>